const priceFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
})

/**
 * Format a numeric amount as a French EUR currency string (e.g. "1 000,00 €").
 * Non-numeric input falls back to "0,00 €".
 * @param {number | string} value
 * @returns {string}
 */
export function formatPrice (value: number | string): string {
  const numValue = Number(value)
  return priceFormatter.format(Number.isNaN(numValue) ? 0 : numValue)
}
